module.exports = __webpack_public_path__ + "static/media/map-marker.d3af08c5.svg";